import { ArrayUtils, typeChecker } from '@shopping/common'
import { LikeParam, LikeReactionType, Likes, LikeServiceType, LikesParam } from 'common/types/entities/api/like'
import { isErrorRejected } from 'common/utils/ajax/apiErrorHandler'
import { Review } from 'common/types/entities/api/review'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export const setLike = async ({ contentId, serviceId, reactionType }: LikeParam) => {
  const response = await axios.post(
    `/v1/likes/services/${serviceId}/contents/${contentId}`,
    {
      [isErrorRejected]: true,
    },
    {
      params: {
        reactionType,
      },
    },
  )
  return response && response.data
}

export const deleteLike = async ({ contentId, serviceId, reactionType }: LikeParam) => {
  const response = await axios.delete(`/v1/likes/services/${serviceId}/contents/${contentId}`, {
    data: {
      [isErrorRejected]: true,
    },
    params: {
      reactionType,
    },
  })
  return response && response.data
}

export const getLikes = async ({ serviceId, contentIds }: LikesParam, headers: any): Promise<Likes> => {
  if (headers && headers.cookie && headers.cookie.includes('NID_SES')) {
    const response = await axios.get<Likes>(`/v1/likes/services/${serviceId}/contents`, {
      ...getHeaders(headers),
      params: {
        contentIds,
      },
    })

    return response && response.data
  }
  return null
}

export const getReviewsSetLikes = async (reviews: Review[], headers: any) => {
  if (!typeChecker.isArray(reviews)) {
    return []
  }
  if (ArrayUtils.isEmpty(reviews)) {
    return reviews
  }
  const likesCounts: Likes = await getLikes(
    { serviceId: LikeServiceType.SMARTSTORE, contentIds: reviews.map(review => review.id) },
    headers,
  )

  if (!(likesCounts && ArrayUtils.isNotEmpty(likesCounts.contents))) {
    return reviews
  }
  const likeContents = likesCounts.contents
  return reviews.map(review => {
    const reviewSetLikes = { ...review }
    const selectedContents = likeContents.filter(
      content => content.serviceId === LikeServiceType.SMARTSTORE && content.contentsId === String(reviewSetLikes.id),
    )
    if (ArrayUtils.isNotEmpty(selectedContents)) {
      const selectedReactions = selectedContents[0].reactions.filter(
        reaction => reaction.reactionType === LikeReactionType.USEFUL,
      )
      if (ArrayUtils.isNotEmpty(selectedReactions)) {
        reviewSetLikes.helpCount = selectedReactions[0].count
        reviewSetLikes.isMyLike = selectedReactions[0].isReacted
      }
    }
    return reviewSetLikes
  })
}
